var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _g, _path100, _g2, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 64,
    viewBox: "0 0 120 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1026:25969",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H120V64H0V0Z",
    fill: "#ECECEC"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1026:25969)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4243 36.7511H94.4103V6.98633H55.4243V36.7511Z",
    fill: "#0450CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4458 7.25899H94.4335V6.29395H55.4458V7.25899Z",
    fill: "#0450CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4453 7.25344H94.433V7.18848H55.4453V7.25344Z",
    fill: "#003E99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9546 6.87106H91.0909V6.74609H90.9546V6.87106Z",
    fill: "#003E99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.5454 7.11308H94.2306V6.50488H91.5454V7.11308Z",
    fill: "#9AC7F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.668 6.87195H91.0238V6.74609H90.668V6.87195Z",
    fill: "#9AC7F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6758 6.92156H56.9253V6.64844H56.6758V6.92156Z",
    fill: "#003E99"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8345 6.92156H56.084V6.64844H55.8345V6.92156Z",
    fill: "#9AC7F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2256 6.92156H57.4769V6.64844H57.2256V6.92156Z",
    fill: "#003E99"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4863 8.25052H74.0573V7.90234H62.4863V8.25052Z",
    fill: "#9AC7F7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4434 9.61362H65.3568V9.26562H63.4434V9.61362Z",
    fill: "#FF876C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4434 10.9759H65.3568V10.6279H63.4434V10.9759Z",
    fill: "#FF876C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4434 12.3392H65.3568V11.9912H63.4434V12.3392Z",
    fill: "#FF876C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0972 9.61362H74.9703V9.26562H69.0972V9.61362Z",
    fill: "#7EC896"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0972 10.9759H74.9703V10.6279H69.0972V10.9759Z",
    fill: "#7EC896"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0972 12.3392H74.9703V11.9912H69.0972V12.3392Z",
    fill: "#7EC896"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1841 9.61362H67.5329V9.26562H66.1841V9.61362Z",
    fill: "#C5E1F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1841 10.9759H67.5329V10.6279H66.1841V10.9759Z",
    fill: "#C5E1F9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1841 12.3392H67.5329V11.9912H66.1841V12.3392Z",
    fill: "#C5E1F9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1147 9.61362H68.4723V9.26562H68.1147V9.61362Z",
    fill: "#FEC12F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1147 10.9759H68.4723V10.6279H68.1147V10.9759Z",
    fill: "#FEC12F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1147 12.3392H68.4723V11.9912H68.1147V12.3392Z",
    fill: "#FEC12F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5298 9.61362H62.8891V9.26562H62.5298V9.61362Z",
    fill: "#FEC12F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5298 10.9759H62.8891V10.6279H62.5298V10.9759Z",
    fill: "#FEC12F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5298 12.3392H62.8891V11.9912H62.5298V12.3392Z",
    fill: "#FEC12F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4434 15.0658H66.4012V14.7178H63.4434V15.0658Z",
    fill: "#FF876C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4902 15.0658H74.9703V14.7178H70.4902V15.0658Z",
    fill: "#7EC896"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.228 15.0658H68.9238V14.7178H67.228V15.0658Z",
    fill: "#C5E1F9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5063 15.0658H69.8657V14.7178H69.5063V15.0658Z",
    fill: "#FEC12F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1431 17.7923H85.721V17.4443H75.1431V17.7923Z",
    fill: "#9AC7F7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4023 17.7923H74.0578V17.4443H67.4023V17.7923Z",
    fill: "#C5E1F9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1904 15.0658H81.3711V14.7178H80.1904V15.0658Z",
    fill: "#7EC896"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2329 15.0658H78.6243V14.7178H76.2329V15.0658Z",
    fill: "#C5E1F9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.2061 15.0658H79.5654V14.7178H79.2061V15.0658Z",
    fill: "#FEC12F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8223 15.0658H82.1816V14.7178H81.8223V15.0658Z",
    fill: "#FEC12F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5298 15.0658H62.8891V14.7178H62.5298V15.0658Z",
    fill: "#FEC12F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4434 20.5179H66.4012V20.1699H63.4434V20.5179Z",
    fill: "#FF876C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5298 20.5179H62.8891V20.1699H62.5298V20.5179Z",
    fill: "#C5E1F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9663 20.5179H67.3256V20.1699H66.9663V20.5179Z",
    fill: "#C5E1F9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1821 25.971H64.1399V25.623H61.1821V25.971Z",
    fill: "#FF876C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2681 25.971H60.6274V25.623H60.2681V25.971Z",
    fill: "#C5E1F9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7061 25.971H65.0636V25.623H64.7061V25.971Z",
    fill: "#C5E1F9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0112 19.1556H65.3688V18.8076H65.0112V19.1556Z",
    fill: "#FEC12F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0112 16.43H66.7512V16.082H65.0112V16.43Z",
    fill: "#FF876C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4033 16.43H74.188V16.082H67.4033V16.43Z",
    fill: "#FEC12F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.105 9.6146H81.6769V9.2666H79.105V9.6146Z",
    fill: "#7EC896"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.105 10.9769H81.6769V10.6289H79.105V10.9769Z",
    fill: "#7EC896"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.105 12.3402H81.6769V11.9922H79.105V12.3402Z",
    fill: "#7EC896"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9805 9.6146H84.4161V9.2666H81.9805V9.6146Z",
    fill: "#7EC896"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9805 10.9769H85.995V10.6289H81.9805V10.9769Z",
    fill: "#7EC896"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9805 12.3402H88.5191V11.9922H81.9805V12.3402Z",
    fill: "#7EC896"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.189 9.6146H77.5378V9.2666H76.189V9.6146Z",
    fill: "#C5E1F9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.189 10.9769H77.5378V10.6289H76.189V10.9769Z",
    fill: "#C5E1F9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.189 12.3402H77.5378V11.9922H76.189V12.3402Z",
    fill: "#C5E1F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1206 9.6146H78.4782V9.2666H78.1206V9.6146Z",
    fill: "#FEC12F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1206 10.9769H78.4782V10.6289H78.1206V10.9769Z",
    fill: "#FEC12F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1206 12.3402H78.4782V11.9922H78.1206V12.3402Z",
    fill: "#FEC12F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7666 9.6146H86.1259V9.2666H85.7666V9.6146Z",
    fill: "#FEC12F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0137 10.9769H87.373V10.6289H87.0137V10.9769Z",
    fill: "#FEC12F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3628 12.3402H89.7221V11.9922H89.3628V12.3402Z",
    fill: "#FEC12F"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4873 13.7033H74.0583V13.3555H62.4873V13.7033Z",
    fill: "#7EB3FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0957 28.8705H63.0091V28.5225H61.0957V28.8705Z",
    fill: "#FF876C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5762 31.5959H67.4896V31.248H65.5762V31.5959Z",
    fill: "#FF876C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2305 31.5959H80.6331V31.248H71.2305V31.5959Z",
    fill: "#7EC896"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6187 30.2328H81.2363V29.8848H62.6187V30.2328Z",
    fill: "#C5E1F9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3159 31.5959H69.6647V31.248H68.3159V31.5959Z",
    fill: "#C5E1F9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2476 31.5959H70.6051V31.248H70.2476V31.5959Z",
    fill: "#FEC12F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1821 28.8705H60.5415V28.5225H60.1821V28.8705Z",
    fill: "#FEC12F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4448 28.8705H63.8041V28.5225H63.4448V28.8705Z",
    fill: "#FEC12F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1426 32.9593H69.0117V32.6113H68.1426V32.9593Z",
    fill: "#FF876C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.23 32.9593H67.5893V32.6113H67.23V32.9593Z",
    fill: "#FEC12F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4468 32.9593H69.8061V32.6113H69.4468V32.9593Z",
    fill: "#FEC12F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5791 35.6849H71.45V35.3369H70.5791V35.6849Z",
    fill: "#FF876C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.665 35.6849H70.0243V35.3369H69.665V35.6849Z",
    fill: "#FEC12F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8833 35.6849H72.2426V35.3369H71.8833V35.6849Z",
    fill: "#FEC12F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6621 31.5959H65.0214V31.248H64.6621V31.5959Z",
    fill: "#FEC12F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.709 34.3216H85.1706V33.9736H69.709V34.3216Z",
    fill: "#C5E1F9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0674 31.5959H81.4267V31.248H81.0674V31.5959Z",
    fill: "#FEC12F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4873 21.8822H78.4074V21.5342H62.4873V21.8822Z",
    fill: "#7EB3FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4873 23.2455H82.7653V22.8975H62.4873V23.2455Z",
    fill: "#7EB3FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4873 24.6078H70.4916V24.2598H62.4873V24.6078Z",
    fill: "#7EB3FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 8.25149H57.0066V7.90332H56.1357V8.25149Z",
    fill: "#FEC12F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 9.6146H57.0066V9.2666H56.1357V9.6146Z",
    fill: "#FEC12F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 10.9769H57.0066V10.6289H56.1357V10.9769Z",
    fill: "#FEC12F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 12.3402H57.0066V11.9922H56.1357V12.3402Z",
    fill: "#FEC12F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 13.7033H57.0066V13.3555H56.1357V13.7033Z",
    fill: "#FEC12F"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 15.0667H57.0066V14.7188H56.1357V15.0667Z",
    fill: "#FEC12F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 16.43H57.0066V16.082H56.1357V16.43Z",
    fill: "#FEC12F"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 17.7933H57.0066V17.4453H56.1357V17.7933Z",
    fill: "#FEC12F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 19.1556H57.0066V18.8076H56.1357V19.1556Z",
    fill: "#FEC12F"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 20.5189H57.0066V20.1709H56.1357V20.5189Z",
    fill: "#FEC12F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 21.8822H57.0066V21.5342H56.1357V21.8822Z",
    fill: "#FEC12F"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 23.2455H57.0066V22.8975H56.1357V23.2455Z",
    fill: "#FEC12F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 24.6078H57.0066V24.2598H56.1357V24.6078Z",
    fill: "#FEC12F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 25.972H57.0066V25.624H56.1357V25.972Z",
    fill: "#FEC12F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 27.3343H57.0066V26.9863H56.1357V27.3343Z",
    fill: "#FEC12F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 28.6976H57.0066V28.3496H56.1357V28.6976Z",
    fill: "#FEC12F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1357 30.0609H57.0066V29.7129H56.1357V30.0609Z",
    fill: "#FEC12F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4336 64.8111H61.6337V34.0693H22.4336V64.8111Z",
    fill: "#E9F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4336 34.1932H61.6337V30.5029H22.4336V34.1932Z",
    fill: "#D4EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1403 32.1778C25.1403 32.585 24.8075 32.9163 24.4022 32.9163C23.9933 32.9163 23.6641 32.585 23.6641 32.1778C23.6641 31.7702 23.9933 31.4404 24.4022 31.4404C24.8075 31.4404 25.1403 31.7702 25.1403 32.1778Z",
    fill: "#074FDF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4767 32.1778C27.4767 32.585 27.1457 32.9163 26.7386 32.9163C26.3297 32.9163 26.0005 32.585 26.0005 32.1778C26.0005 31.7702 26.3297 31.4404 26.7386 31.4404C27.1457 31.4404 27.4767 31.7702 27.4767 32.1778Z",
    fill: "#8DCFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8127 32.1778C29.8127 32.585 29.4817 32.9163 29.0746 32.9163C28.6674 32.9163 28.3364 32.585 28.3364 32.1778C28.3364 31.7702 28.6674 31.4404 29.0746 31.4404C29.4817 31.4404 29.8127 31.7702 29.8127 32.1778Z",
    fill: "#ACD4F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7383 39.7704H65.5123V33.9971H59.7383V39.7704Z",
    fill: "#C5E1F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1026:25969",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 19,
    width: 50,
    height: 53
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7085 19.4502H76.1289V71.5488H27.7085V19.4502Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1026:25969)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5332 41.3311L43.242 50.7902L41.5923 53.8143C41.5923 53.8143 44.343 56.8383 47.0919 54.9139C49.8408 52.9895 58.3638 45.8417 58.3638 45.8417L53.5332 41.3311Z",
    fill: "#DD000B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.692 51.6473L35.6627 41.2148C35.6627 41.2148 33.4873 41.1286 34.3139 42.5988C35.1405 44.0689 41.5925 53.8144 41.5925 53.8144C41.5925 53.8144 47.1239 56.7741 45.692 51.6473Z",
    fill: "#EC9568"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5246 43.5484C35.5246 43.5484 33.4023 42.3536 32.3243 41.8144C31.2463 41.2753 28.4833 39.2843 28.1523 38.6961C27.8213 38.1081 27.8213 38.1081 27.8213 38.1081L30.5082 39.7041L29.717 38.5555C29.717 38.5555 28.1328 37.6303 27.9522 37.3945C27.7717 37.1586 27.7345 36.8371 27.7345 36.8371C27.6071 36.1787 27.9806 36.1542 27.9806 36.1542L30.0356 37.1437L31.4588 38.2127L30.772 36.9049C30.772 36.9049 29.0107 36.1819 28.8868 35.9615C28.7629 35.7408 28.986 35.3643 28.986 35.3643L31.4411 36.461L33.3811 38.7918C33.3811 38.7918 33.6466 38.4886 33.243 37.9434C32.8394 37.3983 32.7208 36.9297 32.7987 36.6389C32.8784 36.3479 34.0625 37.8517 34.2112 38.204C34.3617 38.5562 35.6609 39.4048 35.7158 40.7922C35.7707 42.1794 35.5246 43.5484 35.5246 43.5484Z",
    fill: "#EC9568"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5327 41.3312C54.4531 40.6547 56.1843 39.4427 58.5332 39.5608C60.8838 39.6788 57.1472 43.3965 55.34 44.5768C53.5327 45.7571 52.6884 45.344 52.6884 45.344C52.6884 45.344 52.3273 42.2164 53.5327 41.3312Z",
    fill: "#DD000B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5456 62.1437C51.5456 62.1437 48.0515 73.3168 52.1475 93.8534C53.0183 98.2196 52.7404 98.8677 53.2325 102.587C54.7583 114.135 54.799 123.242 55.1601 123.596C55.9832 124.403 57.4205 123.881 58.2932 123.596C58.6543 123.479 60.1004 106.482 59.7393 103.531C59.2154 99.2488 58.4418 98.3828 58.4135 95.3877C58.3728 91.0995 61.5059 85.1506 60.704 80.3197C59.8597 75.2444 52.505 59.6831 51.5456 62.1437Z",
    fill: "#212957"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4871 62.3398C66.4871 62.3398 69.8627 69.5395 70.2237 72.8442C70.5707 76.0128 70.8256 94.9151 70.8256 94.9151C70.8256 94.9151 73.5975 101.289 74.4418 104.357C75.2844 107.426 76.1287 123.478 76.1287 123.478L72.2717 123.714L59.9803 79.5717L51.5459 62.8512L66.4871 62.3398Z",
    fill: "#3B47BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8246 39.738C65.8246 39.738 68.6567 42.4526 68.2956 45.0491C67.9327 47.6458 66.568 48.767 66.0866 52.0717C65.6033 55.3764 64.7201 60.8451 66.4069 62.1434C68.0938 63.4416 63.9483 69.7525 50.7258 67.4016C50.078 67.2866 53.4323 54.216 51.7861 50.4981C51.1613 49.0865 51.3648 45.8754 53.2924 44.6951C55.2201 43.5148 58.0522 39.502 58.0522 39.502C58.0522 39.502 64.0775 38.8528 65.8246 39.738Z",
    fill: "#FD2227"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8247 39.7373C65.8247 39.7373 68.6568 39.9734 69.6799 42.1568C70.7048 44.3404 73.1758 54.0776 73.1758 56.4971C73.1758 58.9166 72.8749 59.9788 72.8749 59.9788L66.4265 56.6152C66.4265 56.6152 64.9804 39.9734 65.8247 39.7373Z",
    fill: "#DD000B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8751 59.9793C72.8751 59.9793 72.7547 61.3366 72.7547 61.6317C72.7547 61.9268 71.4289 62.281 70.043 62.281C68.657 62.281 58.4136 56.4976 57.4506 56.0845C56.4859 55.6713 54.2574 55.0814 53.714 55.0222C53.1724 54.9633 52.7511 53.4879 53.052 52.5436C53.2502 51.9189 53.4503 51.3716 53.7547 51.1925C53.9105 51.101 54.0928 51.1056 54.3158 51.2454C54.9796 51.6586 57.6312 53.9011 57.6312 53.9011C57.6312 53.9011 63.8371 55.0222 66.3063 56.0845C68.7774 57.1467 71.6697 58.445 72.8751 59.9793Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5806 51.5993L53.7543 51.1924L53.0516 52.5435L53.4729 54.609L51.7258 54.9041C51.7258 54.9041 51.4851 54.609 51.786 54.4911C52.0869 54.373 52.5082 54.196 52.5082 54.196C52.5082 54.196 51.6656 54.078 51.3045 54.019C50.9417 53.9599 50.8815 53.8418 50.8815 53.6648C50.8815 53.4878 51.2443 53.3698 51.2443 53.3698C51.2443 53.3698 50.5806 53.1338 50.5204 52.9566C50.4602 52.7796 50.3398 52.5435 50.4602 52.3665C50.5806 52.1895 50.4 51.7174 50.5806 51.5993Z",
    fill: "#EC9568"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5115 36.3642C65.5115 36.3642 70.8412 35.83 70.8094 33.5813C70.7775 31.3324 68.133 30.6072 69.4925 28.7034C70.8501 26.7998 73.0238 25.249 68.7561 24.3801C64.4884 23.5107 66.8303 19.3779 63.8247 19.4512C60.8208 19.5241 60.4757 21.4475 57.6772 21.7492C54.8769 22.0512 51.204 20.1818 49.8694 23.7719C48.5347 27.3623 48.9843 30.631 50.7438 30.74C52.5015 30.8487 50.4978 32.4963 50.1083 33.7252C49.7207 34.954 51.2005 39.3668 58.1144 36.1655C65.0265 32.9637 62.2387 36.5074 65.5115 36.3642Z",
    fill: "#202954"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6319 34.9968C62.6319 34.9968 62.4159 36.7248 62.5522 38.0263C62.6956 39.41 64.6445 39.2742 62.6018 40.6306C60.0015 42.3575 57.4102 40.2688 57.4102 40.2688C57.4102 40.2688 58.5448 38.9563 58.5395 37.3068C58.5342 35.5871 57.1623 34.4081 59.2174 34.6428C61.2725 34.8779 62.7505 33.8379 62.6319 34.9968Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1054 38.4591C61.4187 38.3959 62.6312 34.9968 62.6312 34.9968C62.7498 33.8379 61.2718 34.8779 59.2167 34.6428C57.1617 34.4081 58.5335 35.5871 58.5388 37.3068C58.5388 37.3229 58.537 37.3384 58.537 37.3547C58.8556 38.2229 59.7902 38.7232 61.1054 38.4591Z",
    fill: "#EC9568"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5222 25.7061C63.5222 25.7061 64.632 31.9335 63.4248 33.682C61.0724 37.0901 60.6281 37.1292 58.8368 36.6042C57.0473 36.0789 55.5285 32.9998 55.2843 30.1282C55.0524 27.3921 56.1746 27.9631 58.5129 27.5696C61.0618 27.1407 61.5362 26.5019 61.5362 26.5019C61.5362 26.5019 61.2335 27.662 59.559 28.0831C59.4616 28.1075 62.2123 30.0104 63.5222 25.7061Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7423 32.9557C58.1829 32.8974 57.6289 32.8551 57.0819 32.8271C57.0607 33.8531 57.8909 34.7493 59.0131 34.8668C60.1123 34.9815 61.1 34.3099 61.3284 33.3355C60.4911 33.178 59.6291 33.0484 58.7423 32.9557Z",
    fill: "white"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8186 9.71163C47.8008 4.33325 44.5492 -0.0174186 38.6814 5.24351e-05C32.8136 0.017983 29.5867 4.3876 29.6026 9.76686C29.615 13.9621 32.5622 15.4099 35.0687 18.8824C35.5661 19.5695 35.0793 22.2737 35.0793 22.2737L42.4163 22.2519C42.4163 22.2519 41.9135 19.5501 42.4056 18.861C44.8926 15.3723 47.8309 13.9076 47.8186 9.71163Z",
    fill: "#FEC12F"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1374 20.4701C34.6716 15.6719 30.6005 13.671 30.5828 7.87333C30.5792 6.62649 30.7031 5.41929 30.9474 4.27246C30.057 5.83845 29.5968 7.72978 29.6021 9.76678C29.6145 13.962 32.5617 15.4098 35.0681 18.8823C35.5655 19.5695 35.0787 22.2736 35.0787 22.2736L38.4437 22.2635C38.4525 21.5084 38.3817 20.8101 38.1374 20.4701Z",
    fill: "#FFAB01"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9531 22.2744L34.9567 23.2859C34.962 24.9625 36.3232 26.3175 38.0012 26.3127L39.5182 26.3084C41.1962 26.3033 42.5503 24.9396 42.545 23.2632L42.5414 22.252L34.9531 22.2744Z",
    fill: "#12344A"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9921 9.6656L35.8488 8.53859L37.0153 10.0527L38.1729 8.53133L39.3412 10.0453L40.5005 8.52408L41.6688 10.0382L42.83 8.51576L43.7009 9.63976L44.3009 9.17493L42.8247 7.27051L41.6653 8.79118L40.497 7.2767L39.3376 8.79808L38.1694 7.28325L37.0117 8.80446L35.8435 7.2898L34.3867 9.20644L34.9921 9.6656Z",
    fill: "#F4DA80"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6758 10.8811L37.3521 15.8334L37.3715 22.1395L38.1309 22.1372L38.1114 15.7075L36.3944 10.6377L35.6758 10.8811Z",
    fill: "#F4DA80"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3676 10.623L39.6807 15.703L39.7001 22.1328L40.4577 22.1307L40.44 15.8246L42.088 10.8622L41.3676 10.623Z",
    fill: "#F4DA80"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7661 23.5644L37.0223 23.5784L37.0205 22.7902L41.7643 22.7764L41.7661 23.5644Z",
    fill: "#34688F"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4415 24.9913L37.0252 25.0014L37.0234 24.2134L40.4379 24.2031L40.4415 24.9913Z",
    fill: "#34688F"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8198 43.2328C74.8198 42.5536 75.3703 42.0029 76.05 42.0029H92.6003C93.28 42.0029 93.8305 42.5536 93.8305 43.2328V52.4563C93.8305 53.1355 93.28 53.6861 92.6003 53.6861H76.05C75.3703 53.6861 74.8198 53.1355 74.8198 52.4563V43.2328Z",
    fill: "#4E99FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.198 39.2246L87.3859 42.413L84.198 45.6017L81.0083 42.413L84.198 39.2246Z",
    fill: "#4E99FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5954 47.5897L81.5957 48.8022V49.7414L77.6768 47.9251V47.2254L81.5957 45.4141V46.3534L78.5954 47.5897Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1679 51.2742H82.4067L85.3203 43.6982H86.0761L83.1679 51.2742Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1733 47.5609L87.0049 46.3195V45.4092L91.0973 47.2205V47.9202L87.0049 49.7363V48.8166L90.1733 47.5609Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProgram);
export default __webpack_public_path__ + "static/media/img_program.973a19ed0c58f4487703294f34a0a64e.svg";
export { ForwardRef as ReactComponent };